import { render, staticRenderFns } from "./StartupTrackersPopup.vue?vue&type=template&id=3f23d1a4&scoped=true&"
import script from "./StartupTrackersPopup.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupTrackersPopup.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f23d1a4",
  null
  
)

export default component.exports